module.exports = __webpack_public_path__ + "img/BESS.7f8e4080.svg";